module.exports = __webpack_public_path__ + "img/et-serena.472c3815.jpg";